/**
 * 保留两位小数 整数自动补全
 */
export const returnFloat = (param) => {
  param = Math.round(parseFloat(param) * 100) / 100;
  let xsd = param.toString().split(".");
  if (xsd.length == 1) {
    param = param.toString() + ".00";
    return param;
  }
  if (xsd.length > 1) {
    if (xsd.length < 2) {
      param = param.toString() + "0";
    }
    return param;
  }
};
